var _defs, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "p",
    width: 100,
    height: 100,
    patternUnits: "userSpaceOnUse",
    patternTransform: "rotate(90) scale(0.3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    "data-color": "outline",
    fill: "none",
    stroke: "#FAF8F1",
    strokeWidth: 11.78,
    r: 0.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    y: 100
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 100
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 100,
    y: 100
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 50,
    y: 50
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#C58940",
    width: "100%",
    height: "100%"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#p)",
    width: "100%",
    height: "100%"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.1faa8ddb3ec333828d702fb7b6b19277.svg";
export { ForwardRef as ReactComponent };